import { colors } from '../../constants';
const MuiLinearProgress = {
  root: {
    height: 5,
    borderRadius: 2.5
  },
  barColorPrimary: {
    backgroundColor: colors.error.light
  },
  colorPrimary: {
    backgroundColor: colors.oriGrey[100]
  },
  dashedColorPrimary: {
    backgroundImage: `radial-gradient(${colors.oriGrey[100]} 0%, ${colors.oriGrey[100]} 16%, transparent 42%)`
  } // primary,

};
export default MuiLinearProgress;